var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-item",class:{selected: _vm.active == _vm.item.id},on:{"click":function($event){return _vm.select(_vm.item)}}},[_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":20}},[_vm._t("default")],2),_vm._v(" "),_c('el-col',{staticClass:"text-right",attrs:{"span":4}},[_c('i',{staticClass:"ico ico-check"})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6524b34d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckboxItem.vue
// module id = null
// module chunks = 